import { LocaleCard } from 'components/LocaleCard/LocaleCard';
import React, { useState } from 'react';
import { SingleGarageType } from 'types/CommonTypes';
import { Wrapper, LoadMoreStyled } from './GarageListMobile.styled';

interface GarageListMobileProps {
    data: SingleGarageType[];
    investmentSlug: string;
}

export const GarageListMobile = ({
    data,
    investmentSlug,
}: GarageListMobileProps) => {
    const [numberOfRows, setNumberOfRows] = useState(5);
    const cutGarages = data?.slice(0, numberOfRows);
    const loadMore = () => {
        setNumberOfRows((prevState) => prevState + 5);
    };
    return (
        <Wrapper>
            {cutGarages?.map((item) => (
                <LocaleCard
                    investmentSlug={investmentSlug}
                    localeNumber={item?.garageNumber}
                    status={item?.garageStatus}
                    price={item?.garagePrice}
                    yardge={item?.garageArea}
                />
            ))}
            {data.length > numberOfRows && (
                <LoadMoreStyled onClick={loadMore}>
                    Załaduj więcej
                </LoadMoreStyled>
            )}
        </Wrapper>
    );
};
